

<particle-workflow-right-side-bar-designer  [section]="section" [flowChartDataService]="flowChartDataService"
                              [sourceType]="'PreArrangement'"

></particle-workflow-right-side-bar-designer>
